const destinations = [
  { name: "Cancun", country: "Mexico", flag: "🇲🇽", desc: "Most popular family destination from Fort Smith. Direct flights via Dallas-Fort Worth." },
  { name: "Germany", country: "Germany", flag: "🇩🇪", desc: "Ebbing ANG Base military personnel frequently assigned to Ramstein and other German installations." },
  { name: "Japan", country: "Japan", flag: "🇯🇵", desc: "Yokota Air Base and Misawa assignments for Guard and Reserve units." },
  { name: "Caribbean Cruises", country: "Various", flag: "🚢", desc: "Galveston cruise port is 5 hours away — popular for Fort Smith families." },
  { name: "London", country: "UK", flag: "🇬🇧", desc: "UAFS international programs and local business travel." },
  { name: "Costa Rica", country: "Costa Rica", flag: "🇨🇷", desc: "Adventure travel and church mission trips from the Fort Smith faith community." },
];

export default function FortSmithDestinationsSection() {
  return (
    <section id="destinations" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Where Fort Smith Travelers Go</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((d, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">{d.flag}</span>
                <div><h3 className="font-bold text-[#1A365D] text-lg">{d.name}</h3><p className="text-gray-400 text-xs">{d.country}</p></div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}